export default __webpack_public_path__ + "cad07ef287f104583dcbabccca1193a1.svg";